import React from 'react';
import { Link } from 'react-router-dom';
import { PartyPopper, Phone, CalendarCheck, Package } from 'lucide-react';

const HeroSection = () => (
  <section className="relative py-20 px-6 overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0 opacity-10 bg-gradient-to-br from-orange-200 via-pink-100 to-purple-200"></div>
    <div className="max-w-7xl mx-auto relative z-10">
      <div className="text-center">
        <div>
          <div className="flex items-center justify-center gap-3 mb-6">
            <PartyPopper size={48} className="text-orange-500 hidden sm:block" />
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold heading-font" style={{ color: '#7C3AED' }} data-testid="hero-title">
              Party Rentals, Tents, Tables & Chairs in Philadelphia and Delaware County
            </h1>
          </div>
          <p className="text-lg sm:text-xl text-gray-700 max-w-4xl mx-auto mb-8" data-testid="hero-subtitle">
            Thomas Party & Decor is a party rental company based in Aldan, Pennsylvania, serving Philadelphia, Delaware County, the Main Line, and nearby Montgomery County communities. We provide tent rentals, tables, chairs, linens, cocktail tables, throne chairs, backdrops, balloon décor, dinnerware, and complete event packages for weddings, graduations, birthdays, baby showers, backyard celebrations, and corporate events.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/request-a-quote"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg transition-all hover:scale-105"
              data-testid="request-quote-button"
            >
              Request a Quote
            </Link>
            <Link
              to="/packages"
              className="inline-flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg transition-all hover:scale-105"
              data-testid="browse-packages-button"
            >
              <Package size={20} />
              Browse Rental Packages
            </Link>
            <a
              href="tel:484-957-0076"
              className="inline-flex items-center gap-2 bg-white px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all border-2 border-orange-300 hover:border-orange-500 font-bold text-lg text-violet-700"
              data-testid="hero-phone"
            >
              <Phone size={20} className="text-orange-500" />
              Call 484-957-0076
            </a>
            <a
              href="mailto:thomaspartydecor@gmail.com?subject=Date%20Availability%20Check"
              className="inline-flex items-center gap-2 bg-white px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all border-2 border-orange-300 hover:border-orange-500 font-bold text-lg text-violet-700"
              data-testid="check-availability-button"
            >
              <CalendarCheck size={20} className="text-orange-500" />
              Check Date Availability
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
